<template>
    <div id="marketplace-products-listing" class="wspro-product-listing">
        <div id="worksends-page-header" class="tw-grid tw-mt-2 tw-grid-cols-2">
            <div>
                <div class="breadcrumbs" id="breadcrumbs">
                    <span class="breadcrumb-link">Marketplace</span>  &gt;
                    <router-link class="breadcrumb-link" to="/marketplace/digital">eGifts Selection</router-link>
                </div>
                <h3 style="float: left;">Marketplace <span>eGifts Selection</span></h3>
            </div>
            <div class="ws-filters tw-flex tw-justify-end">
                <div class="ws-filter ws-filter-select">
                    <label>eGift Category</label>
                    <select v-model="pageParams.filters.category.val" name="marketplace-product-type" @change="setFilter">
                        <option value="null">All Categories</option>
                        <option v-for="term in categoryTerms" v-bind:value="term.value">{{ term.text }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="wspro-product-list">
            <div v-for="item in index.data" :key="item.id" class="wspro-product-list-item">
                <product-list-item location="marketplace" :item="item" @open-detail-modal="openDetailModal" @open-send-modal="openSendModal" @open-link-modal="openLinkModal"></product-list-item>
            </div>
        </div>

        <div class="note" v-if="index.meta && index.meta.total == 0 && !$wait.any"><b>There are no available Marketplace products that match your filters.</b><br>We advise you to try different filter options.</div>
        <ws-table-meta v-if="!$wait.any" :meta="index.meta" format="grid" :sum="'% Bookblock HUB Marketplace eGifts'+((pageParams.filters.category.val)?' that match your filters':'')+'.'"></ws-table-meta>

        <marketplace-product-modal v-if="modals.marketplaceProductModal" :voucher-brand="voucherBrand" @open-send-modal="openSendModal" @open-link-modal="openLinkModal"></marketplace-product-modal>
        <gift-registration-modal v-if="modals.giftRegistrationModal" :voucher-brand="voucherBrand" platform="marketplace" :fetch-item="false" @created="onDirectSend" :type="'create'"></gift-registration-modal>
        <gift-invite-modal v-if="modals.giftInviteModal" :voucher-brand="voucherBrand" :registration-link-details="registrationLinkDetails" platform="marketplace" @generated="onLinkGenerate"></gift-invite-modal>
    </div>
</template>

<script>
import ProductListItem from "@/components/ProductListItem";
import MarketplaceProductModal from "@/pages/marketplace/MarketplaceProductModal";
import GiftRegistrationModal from '@/components/modals/GiftRegistrationModal';
import GiftInviteModal from '@/components/modals/GiftInviteModal';

export default {
    name: "MarketplaceDigitalGiftsIndex",
    components: {ProductListItem,MarketplaceProductModal,GiftRegistrationModal,GiftInviteModal},
    data() {
        return {
            pageParams: {
                pageOptions: {page:1, sortBy:[], sortDesc:[], itemsPerPage: 1000},
                search: {val: ""},
                filters: {
                    category: { val: null, type: 'single' },
                }
            },
            errors: {},
            voucherBrand: null,
        }
    },
    methods: {
        async getPage(params) {
            this.getPageHandler({
                waitName: 'marketplace.physical.index',
                action: 'fetchMarketplaceDigitalProducts', // vuex action
                pageParams: this.pageParams,
                isInit: params ? params.init : false, // parse from url query params
                pushRoute: true, // push pagination params and search q to route
                resetPagination: params ? params.resetPagination : false, // new search input -> need to reset page & sorting
                routeParams: {teamId: parseInt(this.team.id)},
            });
        },
        async fetchData() {

        },
        async setFilter(event) {
            this.getPage();
        },
        openDetailModal(brand) {
            this.voucherBrand = brand;
            this.modals.marketplaceProductModal = true;
        },
        openSendModal(brand) {
            this.voucherBrand = brand;
            this.modals.giftRegistrationModal = true;
        },
        openLinkModal(brand) {
            this.voucherBrand = brand;
            this.modals.giftInviteModal = true;
        },
        onLinkGenerate() {

        },
        onDirectSend() {
			this.modals.giftRegistrationModal = false;
		},

    },
    mounted() {
        this.pageParams.pageOptions.itemsPerPage = this.itemsPerPageCookie(this.$options.name,24);
        this.getPage({init:true});
        this.fetchData();
    },
    computed: {
        team() {
			return this.$store.state.team.detail;
		},
        index() {
            return this.$store.state.product.index;
        },
        item() {
            return this.$store.state.product.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        categoryTerms() {
            return this.$store.state.voucherCategories;
        }
    },
    watch: {
        'pageParams.pageOptions': {
            handler (newVal, oldVal) {
                if (oldVal != null) { // we need to load initial data based on url query instead
                    //this.getPage();
                }
            },
            deep: true,
        },
        'team.id': {
            handler (newVal) {
                if (newVal != null) {
                    this.getPage({init:true});
                }
            },
        },
    },
}
</script>

<style scoped>

</style>
